const globalMapAnimations = () => {
    const map = document.querySelector('.world-map');
    if(!map) return;
    const mapInner = document.querySelector('.world-map__inner');
    map.addEventListener('transitionend', () => {
        if(mapInner){
            mapInner.classList.add('anim-map-markers');
        }
    }, {once:true})
}
globalMapAnimations()
